import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Coins icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Coins } from '@sravni/design-system-icons'
 *
 * <Coins />
 * ```
 */
var Coins = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Coins", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.999 8.125a4.792 4.792 0 1 0 0 9.584 4.792 4.792 0 0 0 0-9.584Zm-6.042 4.792a6.042 6.042 0 1 1 12.084 0 6.042 6.042 0 0 1-12.084 0Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.24 10.533a.625.625 0 0 1 .385.578v3.611a.625.625 0 1 1-1.25 0v-2.148a.625.625 0 0 1-.72-1.002l.903-.903a.625.625 0 0 1 .681-.136Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.473 14.725c0-.345.28-.625.625-.625h1.8a.625.625 0 1 1 0 1.25h-1.8a.625.625 0 0 1-.625-.625ZM12.164 3.958A4.793 4.793 0 0 0 7.479 7.75a.625.625 0 1 1-1.223-.26 6.041 6.041 0 1 1 7.168 7.168.625.625 0 1 1-.26-1.223 4.792 4.792 0 0 0-1-9.477Z", fill: "currentColor" }))); });

export { Coins };
//# sourceMappingURL=Coins.js.map
